import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicFieldDropdown, BaasicButton, BasicInput, DatePickerField } from 'core/components';

function PatientInsuranceEditModalTemplate({ patientInsuranceEditModalViewStore, t }) {
    const {
        form,
        modalParams,
        primaryInsuranceStore,
        secondaryInsuranceStore,
        patient
    } = patientInsuranceEditModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Edit Patient Insurance</h3>
            </div>

            <div className="modal__body">
                <div>
                    <div className="form__title">
                        <h4 className="form__title--secondary">Active insurances</h4>
                    </div>
                    {
                        patient && patient.primaryActivePayor &&
                        <div className="card card--secondary u-mar--bottom--sml">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label">Primary Insurance</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">{patient.primaryActivePayor.payorPolicyInfo.name}
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label">Policy Number</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">{patient.primaryActivePayor.payorPolicyInfo.policyNumber}
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label">Start Date</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">{patient.primaryActivePayor.payorPolicyInfo.effectiveDate}
                                </div>
                            </div>
                        </div>
                    }
                    {
                        patient && patient.secondaryActivePayor &&
                        <div className="card card--secondary u-mar--bottom--sml">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label">Secondary Insurance</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">{patient.secondaryActivePayor.payorPolicyInfo.name}
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label">Policy Number</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">{patient.secondaryActivePayor.payorPolicyInfo.policyNumber}
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label">Start Date</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">{patient.secondaryActivePayor.payorPolicyInfo.effectiveDate}
                                </div>
                            </div>
                        </div>
                    }
                    {
                        patient && !patient.primaryActivePayor && !patient.secondaryActivePayor &&
                        <div className="card card--secondary u-mar--bottom--sml">
                            <p>NONE</p>
                        </div>
                    }
                    <div className="form__title">
                        <h4 className="form__title--secondary">Primary insurance information</h4>
                    </div>
                    <div className="row">
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <BaasicFieldDropdown field={form.$('primaryInsuranceName')} store={primaryInsuranceStore} allowEmpty={true} />
                        </div>
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <BasicInput field={form.$('primaryInsurancePolicyNumber')} />
                        </div>
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <DatePickerField field={form.$('primaryInsuranceStartDate')}/>
                        </div>
                    </div>
                </div>

                <div>
                    <h4 className="form__title">Secondary insurance information</h4>
                    <div className="row">
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <BaasicFieldDropdown field={form.$('secondaryInsuranceName')} store={secondaryInsuranceStore} allowEmpty={true} />
                        </div>
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <BasicInput field={form.$('secondaryInsurancePolicyNumber')} />
                        </div>
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <DatePickerField field={form.$('secondaryInsuranceStartDate')} />
                        </div>
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <DatePickerField field={form.$('secondaryInsuranceEndDate')}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='modal__footer'>
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Submit"
                    className='btn btn--med btn--primary'
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section>
    )
}

PatientInsuranceEditModalTemplate.propTypes = {
    patientInsuranceEditModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PatientInsuranceEditModalTemplate);
